// Copyright The OpenTelemetry Authors
// SPDX-License-Identifier: Apache-2.0

import styled from 'styled-components';

const Bar = styled.div`
  background: linear-gradient(93deg, #f46800 0%, #ff8833 100%);
  color: ${({ theme }) => theme.colors.ink};
  text-align: center;
  padding: 8px 16px;
  font-size: 13px;
  font-weight: 600;
  letter-spacing: 0.01em;
`;

const AnnouncementBar = () => {
  return <Bar>Free shipping on orders over $50 · 30-day returns · Every order traced end to end</Bar>;
};

export default AnnouncementBar;
